import { QBS_COLOR_STATUS, QBS_STATUS_TEXT } from '@exam-management/components';

export const QBANK_STRUCTURE_COLOR_STATUS = QBS_COLOR_STATUS;

export const QBANK_STRUCTURE_STATUS_TEXT = QBS_STATUS_TEXT;
